
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class KeepExistingProductPlanOnDiscontinuationSettingDtoModel extends Model<KeepExistingProductPlanOnDiscontinuationSettingDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'sourceTag', type: 'string', languageString: 'keepExistingProductPlanOnDiscontinuationSettingDto.property.sourceTag' },
		{ name: 'destinationTag', type: 'string', languageString: 'keepExistingProductPlanOnDiscontinuationSettingDto.property.destinationTag' }
	];
	[key: string]: any;
	
	public sourceTag: string;
	public destinationTag: string;
    
	constructor(){
		super();
		this.sourceTag = '';
		this.destinationTag = '';
		
	}
	getProperties(){
		return KeepExistingProductPlanOnDiscontinuationSettingDtoModel.classProperties;
	}
}

